module.exports = __webpack_public_path__ + "static/media/Introduksjon-sprakforstaelse.02bede90.mp3";